export const GAME_IDS = {
  PLINKO: 11,
  LIMBO: 15,
  WHEEL: 17,
  CHICKEN: 23,
  CHICKEN_BRANDED: 29,
  CHICKEN_WINTER: 25,
  CHICKEN_CHRISTMAS: 37,
  MINES: 16,
  HALLOWEEN_MINES: 65,
  PLINKO_AZTEC: 27,
  LIMBO_ROCKET: 28,
  ROULETTE: 24,
  TWIST: 38,
  TWIST_CLASSIC: 39,
  TOWER_CRASH: 40,
  CHICKEN_MINES: 41,
  BALLOON: 45,
  CAMEL_CRASH: 49,
  CONTAINER_CRASH: 53,
  CHICKEN_FOOTBALL: 54,
  DICE: 50,
  CANDY_TOWER: 56,
  COIN_FLIP: 58,
};
